import React from 'react'

import FONTS from '@/src/fonts'
import CardHeader from '@mui/material/CardHeader'
import Typography from '@mui/material/Typography'
import Card from '../Common/Card'
import { useTheme } from '@mui/material/styles'

type Props = {
  onTitle?: any
  title?: any
  subheader?: any
  actions?: any
  children: any
  className?: string
  classNameHeader?: string
  classNameContent?: string
  style?: React.CSSProperties
}

const FieldsetCard: React.FC<Props> = ({
  onTitle,
  title,
  subheader = '',
  children,
  className = null,
  classNameHeader = undefined,
  classNameContent = undefined,
  actions = null,
  style = {},
}) => {
  const theme = useTheme()
  const titleHeader = !!title && (
    <Typography
      variant={'h1'}
      style={{
        fontSize: theme.typography.pxToRem(21),
        fontWeight: FONTS.WEIGHT.BOLD,
        paddingRight: 8,
      }}
    >
      {title}
    </Typography>
  )
  return (
    <Card elevate smallRadius className={className} style={style}>
      <div className="ml-8">{!!onTitle && onTitle}</div>
      {!!titleHeader && (
        <CardHeader title={titleHeader} subheader={subheader} className={classNameHeader} />
      )}
      <div className={classNameContent}>{children}</div>
      <div className="mr-5">{actions}</div>
    </Card>
  )
}

export default FieldsetCard
